import useForm from '@eduzz/houston-forms/deprecated/useForm';
import Form from '@eduzz/houston-ui/Forms/deprecated/Form';
import Input from '@eduzz/houston-ui/Forms/Input';
import Alert from '@material-ui/lab/Alert';
import React, { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { tap } from 'rxjs/operators';
import Modal from 'v2/components/Shared/Modal';
import { transferHistoryService } from 'v2/services/transferHistory';

import useStyles from './styles';

interface ICompositionModalProps {
  open: boolean;
  setClose: () => void;
  compositionId: number;
}

interface IFormModel {
  email: string;
}

function CompositionModal({ open, setClose, compositionId }: ICompositionModalProps) {
  const classes = useStyles();
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (open && inputRef.current) {
      inputRef.current.focus();
    }
  }, [open]);

  const mailForm = useForm<IFormModel>({
    initialValues: {
      email: '',
    },
    validationSchema: (yup) => {
      return yup.object().shape({
        email: yup.string().email('O e-mail informado não é um e-mail válido!').required('E-mail obrigatório!'),
      });
    },
    onSubmit: (values) => {
      transferHistoryService
        .setCompositionRequest(compositionId, values.email)
        .pipe(
          tap(
            () => {
              toast.success(`Relatório será enviado para o email: ${values.email}`);
            },
            (err) => {
              toast.error(err);
            }
          )
        )
        .subscribe();
      handleCloseModal();
    },
  });

  const handleCloseModal = () => {
    mailForm.setValues({ email: '' });
    setClose();
  };

  return (
    <Form context={mailForm}>
      <Modal
        keepMounted
        open={open}
        setClose={handleCloseModal}
        textTitle='Composição de saque'
        textReturnButton='Cancelar'
        textProceedButton='Enviar'
        handleProceedClick={mailForm.handleSubmit}
        isProceedButtonDisabled={!mailForm.isValid}
      >
        <p className={classes.subtitle}>Informe o e-mail para envio do relatório.</p>

        <Input id='email' name='email' placeholder='E-mail' ref={inputRef} errorMessage='' />
        {!!mailForm.getFieldError('email') && (
          <Alert severity='warning' className={classes.alert}>
            {mailForm.getFieldError('email')}
          </Alert>
        )}
      </Modal>
    </Form>
  );
}

export default CompositionModal;
